export default [
  {
    for: 'tool-reset-voucher',
    actions: {
      read: true,
      update: true,
    },
  },
];
